import { Fragment } from 'react'
import { cn } from '@playbooks/ui/lib/utils'
import { ActionCardData, sectionTypes } from '@playbooks/action-cards-utils/src'

import { Scope } from '../utils/makeSeparatorScopes'
import Separator from './Separator'
import LastSlide from './LastSlide'
import { useAppContext } from '../contexts/AppContext'

export default function SlidesContainer({
  hideScore,
  isFunnelView,
  scopes,
  lastSlideHtml,
}: {
  hideScore: boolean
  isFunnelView: boolean
  lastSlideHtml: string | undefined | null
  scopes: Scope[]
}) {
  const { data, settings: {isWebplay} } = useAppContext()

  const hasLastSlideHtml = typeof lastSlideHtml === 'string' && lastSlideHtml !== ''

  return (
    <div
      data-role="data-action-cards-sides-scroll-container"
      className={cn(
        'flex flex-col w-full h-full overflow-auto ',

        'group-data-[view=funnel]/app:flex-row',
        'group-data-[view=funnel]/app:items-start',
        'group-data-[view=funnel]/app:overflow-visible',

        !hideScore && !isFunnelView && 'pb-20',
      )}
    >
      {scopes.map(scope => {
        const hidden = scope.scopeId === -1
        const separatorData = scope.sections[0]
        const key = `${scope.scopeId}-${separatorData.placeholder}`
        return (
          <Fragment key={key}>
            <Separator
              key={scope.scopeId}
              id={scope.scopeId}
              sections={scope.sections.filter(section => section.type !== sectionTypes.SEPARATOR) || []}
              isHidden={hidden}
              data={separatorData}
            />
          </Fragment>
        )
      })}

      {isFunnelView && isWebplay && (
        <LastSlide hideScore={hideScore} score={data.score} lastSlideHtml={lastSlideHtml || ''} />
      )}
    </div>
  )
}
